import React, { FC } from 'react';
import { api } from '@api';
import { InfinityList } from '@components/InfinityList/InfinityList';
import { PaymentHistoryItem } from '@components/Cards/PaymentHistoryItem/PaymentHistoryItem';
import moment from 'moment/moment';
import { ListDateItem } from '@components/Cards/ListDateItem/ListDateItem';
import { useRouter } from 'next/router';
import { PageQueries } from '@specs/navigation';
const limit = 10;
interface Props {}
export const List: FC<Props> = ({}) => {
  const router = useRouter();
  const {
    purchaseType
  }: PageQueries = router.query;
  const {
    data,
    fetchNextPage,
    hasNextPage,
    status,
    isFetchingNextPage
  } = api.UserManager.getGoldHistory.useInfiniteQuery({
    limit,
    type: purchaseType
  }, {
    queryKey: ['UserManager.getGoldHistory', {
      limit,
      type: purchaseType
    }],
    getNextPageParam: firstPage => firstPage.nextCursor,
    initialCursor: undefined,
    staleTime: 10 * 60 * 1000 // 10 mins
  });
  return <InfinityList data={data} enabledRef={undefined} isFetchingNextPage={isFetchingNextPage} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} status={status} data-sentry-element="InfinityList" data-sentry-component="List" data-sentry-source-file="List.tsx">
            {(payout, index, pageIndex) => {
      const currentPayoutDate = moment(data?.pages?.[pageIndex]?.items?.[index]?.date);
      const previousPayoutDate = index === 0 ? moment(data?.pages?.[pageIndex - 1]?.items?.[limit - 1]?.date) : moment(data?.pages?.[pageIndex]?.items?.[index - 1]?.date);

      // Сравнение, является ли вторая дата новым днем
      const isNewDay = pageIndex === 0 && index === 0 ? true : !currentPayoutDate.isSame(previousPayoutDate, 'day');
      if (isNewDay) return <React.Fragment key={payout.id}>
                            <ListDateItem date={payout.date} />
                            <PaymentHistoryItem {...payout} />
                        </React.Fragment>;
      return <PaymentHistoryItem key={payout.id} {...payout} />;
    }}
        </InfinityList>;
};